import {
  Box,
  useTheme,
} from '@mui/material';
import { keyframes } from '@mui/system';

export function ThinkingDots() {
  const theme = useTheme();

  // Each dot rests at full size in the primary color, and in turn briefly shrinks
  // and lightens, so a single smaller/lighter dot travels across the row.
  const dotDim = keyframes`
    0%, 60%, 100% { transform: scale(1); background-color: ${theme.palette.brand.primary}; }
    30% { transform: scale(0.667); background-color: ${theme.palette.brand.primary}; opacity: 0.5; }
  `;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(0.25),
        backgroundColor: theme.palette.grey[50],
        borderRadius: theme.spacing(1),
        padding: `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(1.75)}`,
      }}
    >
      {[0, 1, 2].map((index) => (
        <Box
          key={index}
          sx={{
            width: theme.spacing(2),
            height: theme.spacing(2),
            borderRadius: '50%',
            backgroundColor: theme.palette.brand.primary,
            animation: `${dotDim} 1.2s ${index * 0.16}s infinite ease-in-out`,
          }}
        />
      ))}
    </Box>
  );
}
